<diy-loop-categorical #loop [question]="question"></diy-loop-categorical>
